module.exports = __webpack_public_path__ + "img/customer_active.15fe82b1.svg";